import { create } from 'zustand';

interface DiscountStore {
  vendors: string[];
}

let vendors: DiscountStore = {
  vendors: []
};

export interface DiscountState {
  actions: {
    addVendor: (vendorId: string) => void;
    addFromMap: (vendorMap: Map<string, any>) => void;
  };
  vendors: DiscountStore
}

export const useDiscountStore = create<DiscountState>((set) => ({
  vendors,
  actions: {
    addVendor: (vendorId: string) => {
      set((state) => ({
        vendors: { ...state.vendors, vendors: [...state.vendors.vendors, vendorId] }
      }));
    },
    addFromMap: (vendorMap: Map<string, any>) => {
      set((state) => ({
        vendors: { ...state.vendors, vendors: [...state.vendors.vendors, ...Array.from(vendorMap.keys())] }
      }));
    }
  }
}));
